export const TOGGLE_CART_BOX_HEADER = "TOGGLE_CART_BOX_HEADER";

export const setCartBoxHeader = () => ({
  type: TOGGLE_CART_BOX_HEADER
});
